<template>
    <div>
        <canvas ref="comparisonChart"></canvas>
    </div>
</template>

<script>
    import Chart from 'chart.js';

    export default {
        name: 'ComparisonChart',
        props: {
            chartDatas: {type: Object, required: true}
        },
        data(){
            return {
                chartObj: undefined,
                chartOptions: {
                    responsive: true,
                    plugins: {
                      title: {
                        display: true,
                        text: "PlayTime Comparison Across Stages"
                      },
                      legend: {
                        position: "top"
                      }
                    },
                    scales: {
                      x: {
                        title: {
                          display: true,
                          text: "Stage"
                        }
                      },
                      y: {
                        title: {
                          display: true,
                        }
                      }
                    },
                }
            }
        },
        mounted() {
            this.updateChart();
        },
        methods: {
            updateChart() {
                if (this.chartObj) {
                    this.chartObj.destroy();
                }
                this.renderChart(); // Or any method to re-create the chart
            },
            renderChart() {
                if (this.$refs.comparisonChart) {
                    this.chartObj = new Chart(this.$refs.comparisonChart, {
                        type: 'line', // Change to your desired chart type
                        data: this.chartDatas,
                        options: this.chartOptions
                    });
                }
            },
        },
        watch: {
            chartDatas: {
                handler() {
                    this.updateChart();
                },
                deep: true
            }
        }
    };
</script>